module.exports = __webpack_public_path__ + "static/img/product-12.e728cc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-12.png
// module id = f1by
// module chunks = 0